import { css } from '@emotion/react';

export const dropdownIndicatorStyle = css`
  transition: transform 0.3s;
`;

export const dropdownIndicatorOpenStyle = css`
  transform: rotate(180deg);
`;
